<template>
    <div class="sidebar left " :class="{fliph: collapsed}" >
        <span style="display:none">{{menus}}</span>
        <div class="user-panel">
            <div class="pull-left image">
            <img src="@/assets/img/octoffice.png" class="logo" alt="Octoffice">
            <span style="font-size: 12px;"> {{ version }} </span>
            <hr>
            </div>
        </div>
        <ul class="list-sidebar">
            <li>
                <span>
                     <router-link to="/" tag="a" :title="$t('menus.home')" >  
                        <b-icon icon="grid3x3-gap-fill" class="color-1"></b-icon> 
                        <span class="nav-label"> {{$t('menus.home')}} </span>
                    </router-link>
                </span>
            </li>
            <li v-for="(menu, index) in menus" :key="menu.id"
             @mouseenter="accordionMenu('menu-'+menu.id, collapsed, 'enter', menu.children ? menu.children.length : 0)"
             @mouseleave="accordionMenu('menu-'+menu.id, collapsed, 'leave', menu.children ? menu.children.length : 0)">
                <span   @click="accordionMenu('menu-'+menu.id, collapsed, 'click', menu.children ? menu.children.length : 0)" >
                     <router-link :to="menu.path" tag="a" :title="menu.menu_detail[0].title">  
                        <b-icon :icon="menu.icon" :class="'color-'+(index%12)"></b-icon> 
                        <span class="nav-label"> {{menu.menu_detail[0].title}} </span>
                    </router-link>
                </span>
               
                <template v-if="menu.children">
                    <ul class="sub-menu collapse" :id="'menu-'+menu.id">
                        <li v-for="submenu in menu.children" :key="submenu.id"> 
                            <span>
                                <router-link :to="submenu.path" tag="a" :title="submenu.menu_detail[0].title" > 
                                    <b-icon :icon="submenu.icon" :class="'color-'+(index%12)" ></b-icon>
                                    <span  class="sm-name"> {{submenu.menu_detail[0].title}} </span>  
                                </router-link>
                            </span>
                           
                        </li>
                    </ul>
                </template>
            </li>
        </ul>
        
    </div>
</template>

<script>
    import {version} from '../../package'
    export default {
        name: "DashboardMenu",
        created: async function(){
            //wt_decode(localStorage.getItem('access_token').auth_code
            //await this.$store.dispatch('listUserMenu')
        },
        computed:{
            menus(){
                return this.$store.getters.getAuthMenus
            },
            version(){
                return 'V'+version
            }
        },
        props:{
            collapsed: Boolean
        },
        methods:{
            accordionMenu : (key, collapsed, type, child) => {
                if(child>0){
                    let clsList = document.getElementById(key).classList;
                    let element = document.getElementById(key);
                    let parentLi = element.parentNode;
                 if(!collapsed && type == "click"){
                        parentLi.classList.contains("active") ? parentLi.classList.remove("active") : parentLi.classList.add("active")
                        element.classList.contains("show") ? element.classList.remove("show"): element.classList.add("show")
                    }else if(collapsed){
                        type == 'leave' ? clsList.remove("show") : clsList.add("show")
                        parentLi.classList.remove("active") 
                    }
                }
                
            
            }
        }
    }
</script>

<style lang="css" scoped>
    @import "./styles/dashboardMenu.min.css";
</style>


// WEBPACK FOOTER //
// src/components/DashboardMenu.vue